import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '../../../components/ui/dialog';
import { Button } from '../../../components/ui/button';
import { Label } from '../../../components/ui/label';
import { Textarea } from '../../../components/ui/textarea';
import { Badge } from '../../../components/ui/badge';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../../components/ui/select';
import { UserPlus, User } from 'lucide-react';

export const ReassignDialog = ({ 
  open, 
  onOpenChange, 
  lead,
  reassignForm, 
  setReassignForm, 
  teamMembers,
  onSubmit 
}) => {
  return (
    <Dialog open={open} onOpenChange={(o) => {
      if (!o) {
        onOpenChange({ open: false, lead: null });
        setReassignForm({ newAssigneeId: '', notes: '' });
      }
    }}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <UserPlus className="h-5 w-5" />
            Reassign Lead
          </DialogTitle>
        </DialogHeader>
        <div className="space-y-4 mt-4">
          <div className="p-3 bg-slate-50 rounded-lg">
            <p className="text-sm text-muted-foreground">Lead</p>
            <p className="font-semibold">{lead?.name}</p>
            <p className="text-sm text-muted-foreground">{lead?.phone}</p>
          </div>
          
          <div className="space-y-2">
            <Label>Assign To *</Label>
            <Select value={reassignForm.newAssigneeId} onValueChange={(v) => setReassignForm({...reassignForm, newAssigneeId: v})}>
              <SelectTrigger data-testid="reassign-select">
                <SelectValue placeholder="Select team member" />
              </SelectTrigger>
              <SelectContent>
                {teamMembers.map(member => (
                  <SelectItem key={member.id} value={member.id}>
                    <div className="flex items-center gap-2">
                      <User className="h-4 w-4" />
                      {member.name}
                      <Badge variant="outline" className="text-xs">{member.role}</Badge>
                    </div>
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
          
          <div className="space-y-2">
            <Label>Notes (optional)</Label>
            <Textarea 
              value={reassignForm.notes}
              onChange={(e) => setReassignForm({...reassignForm, notes: e.target.value})}
              placeholder="Add reason for reassignment..."
              rows={2}
            />
          </div>
        </div>
        <DialogFooter className="mt-4">
          <Button variant="outline" onClick={() => onOpenChange({ open: false, lead: null })}>Cancel</Button>
          <Button onClick={onSubmit} data-testid="confirm-reassign-btn">Reassign Lead</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
